import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/theme.css';   // FIRST
import './styles/common.css';  // SECOND
import { ThemeProvider } from './context/ThemeContext';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
